<script lang="ts">
  import { items, clearChecked } from "../stores/data";
  import AddItemBar from "./AddItemBar.svelte";
  import ItemRow from "./ItemRow.svelte";
  import type { GroceryList } from "../types";

  let { list }: { list: GroceryList } = $props();

  const DAY_MS = 24 * 60 * 60 * 1000;

  let doneTodayOpen = $state(false);
  let doneOpen = $state(false);

  // Ticks forward periodically so items roll from "Done Today" into "Done"
  // automatically 24h after being checked, without needing a page reload.
  let now = $state(Date.now());
  $effect(() => {
    const id = setInterval(() => (now = Date.now()), 60_000);
    return () => clearInterval(id);
  });

  let unchecked = $derived(
    $items
      .filter((i) => i.listId === list.id && !i.checked)
      .sort((a, b) => a.position - b.position),
  );
  let checked = $derived(
    $items
      .filter((i) => i.listId === list.id && i.checked)
      .sort((a, b) => b.updatedAt - a.updatedAt),
  );
  let doneToday = $derived(checked.filter((i) => now - i.updatedAt < DAY_MS));
  let doneOlder = $derived(checked.filter((i) => now - i.updatedAt >= DAY_MS));

  function handleClear(): void {
    void clearChecked(list.id);
  }
</script>

<div class="list-view">
  <AddItemBar listId={list.id} />

  <ul class="items">
    {#each unchecked as item (item.id)}
      <ItemRow {item} />
    {/each}
  </ul>

  {#if unchecked.length === 0 && checked.length === 0}
    <p class="empty">No items yet — add your first one above.</p>
  {/if}

  {#if checked.length > 0}
    <div class="done-controls">
      <span class="done-count">{checked.length} done</span>
      <button class="clear" onclick={handleClear} type="button">Clear all</button>
    </div>
  {/if}

  {#if doneToday.length > 0}
    <div class="done-section">
      <button class="done-toggle" onclick={() => (doneTodayOpen = !doneTodayOpen)} type="button">
        {doneTodayOpen ? "▾" : "▸"} Done Today ({doneToday.length})
      </button>
      {#if doneTodayOpen}
        <ul class="items">
          {#each doneToday as item (item.id)}
            <ItemRow {item} />
          {/each}
        </ul>
      {/if}
    </div>
  {/if}

  {#if doneOlder.length > 0}
    <div class="done-section">
      <button class="done-toggle" onclick={() => (doneOpen = !doneOpen)} type="button">
        {doneOpen ? "▾" : "▸"} Done ({doneOlder.length})
      </button>
      {#if doneOpen}
        <ul class="items">
          {#each doneOlder as item (item.id)}
            <ItemRow {item} />
          {/each}
        </ul>
      {/if}
    </div>
  {/if}
</div>

<style>
  .list-view {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }
  .items {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .empty {
    text-align: center;
    color: var(--text-muted);
    padding: 2rem 1rem;
  }
  .done-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid var(--border);
    margin-top: 0.5rem;
    padding: 0.5rem 0.5rem 0.5rem 1rem;
  }
  .done-count {
    color: var(--text-muted);
    font-size: 0.9rem;
  }
  .done-section {
    border-top: 1px solid var(--border);
  }
  .done-toggle {
    width: 100%;
    text-align: left;
    background: var(--surface-alt);
    border: none;
    color: var(--text-muted);
    font-size: 0.9rem;
    cursor: pointer;
    padding: 0.6rem 1rem;
  }
  .clear {
    background: none;
    border: none;
    color: var(--accent);
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
    padding: 0.5rem 0.75rem;
  }
</style>
